import { atom, getDefaultStore } from "jotai";
import { API_URL, } from "./constants";
import { CheckoutUserData, ClassCheckoutDto } from "./domain";
import languageService from "./languageService";
import fetchService from "./FetchService";


export type FormUserData =
    {
        email: string,
        status: boolean,
        code?: string,
        codeValid?: boolean,
        codeMessage?: string,
        sendingEmail: boolean,
        token?: string;
        goingToCheckout?: boolean
    };


const store = getDefaultStore();
export const courseAtom = atom<ClassCheckoutDto | undefined>(undefined);
courseAtom.debugLabel = "courseAtom";

export const userAtom = atom<FormUserData>({ email: "", status: false, sendingEmail: false });
userAtom.debugLabel = "userAtom";


export const sessionAtom = atom<CheckoutUserData>({ lastname: "", firstname: "", email: "" });
userAtom.debugLabel = "sessionAtom";

export const endPoints = {
    GET_CLASS_DATA: (id: string) => `${API_URL}/checkout/${id}/data`,
    GET_SESSION_DATA: (id: string) => `${API_URL}/checkout/${id}/aftercheckout`,
    CHECK_USER: (email: string) => `${API_URL}/login/CheckExistingUser/${email}`,
    CHECK_USER_CODE: (id: string, code: string, token: string) => `${API_URL}/checkout/${id}/checkcode/${code}/${token}`,
    EMIAL_USER_CODE: (id: string, email: string) => `${API_URL}/checkout/${id}/emailcode/${email}`,
    CHECKOUT_URL: (id: string) => `${API_URL}/checkout/${id}/startcheckout`,
}



export class CheckoutService {

    public currentClassId = "";

    constructor() {
        this.getInitData();
    }

    private async getInitData() {

        const params = new URL(document.location.toString()).searchParams;
        const id = params.get("id");
        if (!id) {

            const dummyData: ClassCheckoutDto = {
                CourseDescription: "",
                CourseName: "No id for course",
                Id: "",
                MonthsForAccess: 0,
                Name: "No id for course",
                CookieText:"",
                DataPolicyText:""
            }

            store.set(courseAtom, dummyData);
            return;
        }

        try {
            const status = params.get("status");
            if (status !== undefined && status !== null) {
                const respSession = await fetchService.fetch(endPoints.GET_SESSION_DATA(id),
                    {
                        method: 'GET',
                        credentials: 'include'
                    })

                if (respSession ) {
                    const data = await respSession.json();
                    store.set(sessionAtom, data);
                }
            }

            const respData = await fetchService.fetch(endPoints.GET_CLASS_DATA(id),
                {
                    method: 'GET',
                    credentials: 'include'
                });

            if (respData ) {
                const data = await respData.json();
                store.set(courseAtom, data);
                this.currentClassId = id;
            }

        }
        catch (err) {
            console.error(err);
        }


    }

    public async goToCheckout(values: CheckoutUserData) {

        const data = { ...store.get(userAtom), sendingEmail: true, goingToCheckout: true };
        store.set(userAtom, data);

        const urlArray = [`${window.location.protocol}//${window.location.host}`];
        if (window.location.pathname) urlArray.push(`${window.location.pathname}`)

        const url = urlArray.join("");
        values.classid = this.currentClassId;

        const requestInfo: RequestInit = {
            method: "POST",
            credentials: "include",
            body: JSON.stringify(values),
            headers: { 'Content-Type': 'application/json', 'x-front-referrer': url },
        }
        const response = await fetchService.fetch(
            endPoints.CHECKOUT_URL(this.currentClassId),
            requestInfo
        );

        if (response) {
            const url = await response.json();
            window.location.href = url.Value;
        }

        // if fail no redirect
        data.goingToCheckout = false;
        data.sendingEmail = false;
        store.set(userAtom, data);

    }


    public async sendCode() {
        const data = { ...store.get(userAtom), sendingEmail: true };
        store.set(userAtom, data);


        const response = await fetchService.fetch(
            endPoints.EMIAL_USER_CODE(this.currentClassId, data.email),
            {
                method: "POST",
                credentials: 'include'
            }
        );

        if (response) {
            const answ = await response.json();
            if (answ.Value) {
                store.set(userAtom, {
                    ...data,
                    code: undefined,
                    codeValid: false,
                    codeMessage: languageService.getText("code.sent.by.mail", data.email),
                    sendingEmail: false,
                    token: answ.Value
                });
                return true;
            }
        }
        store.set(userAtom, { ...data, sendingEmail: false });
        return false;


    }

    public async checkCode(code: string) {
        const data = store.get(userAtom);
        if (data.code === code) return data.codeValid;

        if (!data.token) return;

        const response = await fetchService.fetch(endPoints.CHECK_USER_CODE(this.currentClassId, code, data.token!),
            {
                method: 'GET',
                credentials: 'include'
            });

        if (response) {
            const answ = await response.json();
            if (answ.Value) {
                store.set(userAtom, { ...data, codeValid: true });
                return true;
            }
        }
        store.set(userAtom, { ...data, codeValid: false });
        return false;
    }

    resetCode() {
        const data = store.get(userAtom);
        store.set(userAtom, { ...data, code: undefined, codeValid: false });

    }

    public checkEmail(email: string) {

        const data = store.get(userAtom);
        store.set(userAtom, { ...data, email, status: true });
    }



    resetCurrentUser() {
        const data = store.get(userAtom);
        store.set(userAtom, { ...data, email: languageService.getText("email"), status: false });
    }


}
const checkoutService = new CheckoutService();
export default checkoutService;